export default __webpack_public_path__ + "static/media/Eye of the Watcher.8979a984.jpg";